import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const Home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')
const Advertorial = () => import(/* webpackChunkName: "advertorial" */ './views/Advertorial.vue')
const Confirmation = () => import(/* webpackChunkName: "signup" */ './views/Confirmation.vue')
const Emailseries = () => import(/* webpackChunkName: "emailseries" */ './views/EmailSeries.vue')
const Invoice = () => import(/* webpackChunkName: "invoice" */ './views/Invoice.vue')
const NextStep = () => import(/* webpackChunkName: "next" */ './views/NextStep.vue')
const OrderForm = () => import(/* webpackChunkName: "funnel" */ './views/OrderForm.vue')
const Post = () => import(/* webpackChunkName: "post" */ './views/Post.vue')
const SimplePage = () => import(/* webpackChunkName: "simplepage" */ './views/SimplePage.vue')
const Signup = () => import(/* webpackChunkName: "signup" */ './views/Signup.vue')
const Transcript = () => import(/* webpackChunkName: "transcript" */ './views/Transcript.vue')
const VSL = () => import(/* webpackChunkName: "vsl" */ './views/VSL.vue')
const OrderError = () => import(/* webpackChunkName: "ordererror" */ './views/OrderError.vue')

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/artc/:slug/:arguments?',
      name: 'advertorials',
      component: Advertorial
    },
    {
      path: '/confirmation/:slug/:arguments?',
      name: 'confirmation',
      component: Confirmation
    },
    {
      path: '/emailseries/:slug/:arguments?',
      name: 'emailseries',
      component: Emailseries
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: Invoice
    },
    {
      path: '/offer/:slug/:arguments?',
      name: 'offer',
      component: NextStep
    },
    {
      path: '/order/:slug/:arguments?',
      name: 'order',
      component: OrderForm
    },
    {
      path: '/post/:slug/:arguments?',
      name: 'post',
      component: Post
    },
    {
      path: '/p/:slug/:arguments?',
      name: 'simplepage',
      component: SimplePage
    },
    {
      path: '/signup/:slug/:arguments?',
      name: 'signup',
      component: Signup
    },
    {
      path: '/transcript/:slug/:arguments?',
      name: 'transcript',
      component: Transcript
    },
    {
      path: '/vsl/:slug/:arguments?',
      name: 'vsl',
      component: VSL
    },
    {
      path: '/ordererror',
      name: 'ordererror',
      component: OrderError
    },
  ],
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
})
